var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { LazyLoader } from '../../../ts/components/LazyLoader';
export class Search extends Component {
    constructor() {
        super('Search', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $(document).on('facetwp-loaded', () => {
                LazyLoader.refreshImageList();
                LazyLoader.checkImageVisibility();
                this.updateCounters();
                $('.facetwp-facet').each(function (facet) {
                    const facetName = facet.attr('data-name');
                    const facetLabel = FWP.settings.labels[facetName];
                    if (!['width', 'height', 'depth', 'diameter'].includes(facetName))
                        return;
                    facet.prepend($.parseHTML('<p class="fs-small">' + facetLabel + '</p>'));
                });
            });
            $('.filter-title').on('click', (event, filterTitle) => {
                const filter = filterTitle.parent();
                const filterContent = filter.find('.filter-facet-container');
                if (filter.hasClass('is-open')) {
                    filterContent.css('--filter-height', 0);
                    filter.removeClass('is-open');
                }
                else {
                    $('.filter').each((filter) => {
                        filter.find('.filter-facet-container').css('--filter-height', 0);
                        filter.removeClass('is-open');
                    });
                    //filterContent.css('--filter-height', (filter.find('.facetwp-checkbox').length * filter.find('.facetwp-checkbox').height() + 16) + 'px');
                    filterContent.css('--filter-height', filter.find('.filter-facet').height() + 'px');
                    filter.addClass('is-open');
                }
            });
            $('body').on('click', '.facetwp-expand', (event, facetwpExpand) => {
                setTimeout(() => {
                    const filter = facetwpExpand.parents('.filter');
                    const filterContent = filter.find('.filter-facet-container');
                    filterContent.css('--filter-height', filter.find('.filter-facet').height() + 'px');
                }, 100);
            });
            $('.btn-show-filters').on('click', () => {
                $('.search-filters').addClass('is-open');
            });
            $('.btn-close-filters').on('click', () => {
                $('.search-filters').removeClass('is-open');
            });
            // Component initialization done
            this.success();
        });
    }
    updateCounters() {
        $('.filter').each((filter) => {
            let activated = 0;
            filter.find('.facetwp-checkbox, .facetwp-type-slider').each((facetItem) => {
                if (facetItem.hasClass('facetwp-checkbox') && facetItem.hasClass('checked'))
                    activated++;
                if (facetItem.hasClass('facetwp-type-slider') && facetItem.find('.facetwp-slider-reset.facetwp-hidden').length == 0)
                    activated++;
            });
            filter.find('.filter-counter').text(activated === 0 ? '' : activated);
        });
    }
}
